import { createClassName } from 'utils/createClassName';

import './selectBoxStyles.scss';

export const createSelectBoxClassName = createClassName('selectBox');
